import { html, css } from 'lit';
import { BaseComponent } from '../lib/base-component.js';

class MediaThumb extends BaseComponent {
    static properties = {
        src: { type: String },
        alt: { type: String },
        type: { type: String },
    };

    static styles = css`
        :host { display: contents; }
        img, video, .placeholder {
            width: 100%;
            aspect-ratio: 1;
            object-fit: contain;
            background: #f8f9fa;
            transition: opacity 0.15s;
            cursor: pointer;
        }
        img:hover, video:hover, .placeholder:hover { opacity: 0.8; }
        .placeholder {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #6c757d;
            font-size: 0.75rem;
            font-weight: 600;
            letter-spacing: 0.05em;
            text-transform: uppercase;
            border: 1px dashed #ced4da;
            border-radius: 0.25rem;
            gap: 0.25rem;
        }
        .placeholder svg {
            width: 32%;
            height: 32%;
        }
    `;

    constructor() {
        super();
        this.src = '';
        this.alt = '';
        this.type = '';
    }

    _isPSD() {
        return this.type === 'image/vnd.adobe.photoshop' || /\.psd($|\?)/i.test(this.src);
    }

    render() {
        if (!this.src) return html``;
        if (this.src.endsWith('.webm') || this.type === 'video/webm') {
            return html`<video src="${this.src}" autoplay loop muted playsinline @click="${this._handleClick}"></video>`;
        }
        if (this._isPSD()) {
            return html`
                <div class="placeholder" role="img" aria-label="${this.alt || 'PSD file'}" @click="${this._handleClick}">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
                        <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zM9.5 1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5h-2.5A1.5 1.5 0 0 1 9.5 3.5V1z"/>
                    </svg>
                    <span>PSD</span>
                </div>
            `;
        }
        return html`<img src="${this.src}" alt="${this.alt}" @click="${this._handleClick}">`;
    }

    _handleClick() {
        this.dispatchEvent(new CustomEvent('media-click', { bubbles: true, composed: true, detail: { src: this.src } }));
    }
}

if (!customElements.get('media-thumb')) {
    customElements.define('media-thumb', MediaThumb);
}
